<template>
  <Default>
    <div class="col-md-10 ms-auto me-auto">
      <div class="mb-3">
        <router-link to="/order-history" class="btn btn-sm btn-outline-secondary">
          <i class="bi bi-arrow-left me-1"></i>Zpět na přehled
        </router-link>
      </div>
      <h1 class="mb-4">Detail objednávky</h1>
      <order-detail order-id="{{ $route.params.orderId }}" />
    </div>
  </Default>
</template>
<script lang="ts">

import Default from "@/layouts/default.vue";
import OrderDetail from "@/components/gira/orderDetail.vue";

export default{
  name: "OrderDetailView",
  components: {OrderDetail, Default},
  data(){
    return {

    }
  },

}
</script>